import {useUpmPlantTimezone} from '@hconnect/upm'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import {StackProps, Tooltip, Stack, Typography} from '@mui/material'
import {getLocalizedDayMonthTimeFormat} from '@widgets/planning-schedule-chart'
import {Moment} from 'moment-timezone'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'

interface ElectricityChartTitleProps extends StackProps {
  shouldShowDeltaTooltip: boolean
  toggleEcChart: () => void
  isEcChartOpen: boolean
  lastUpdated?: Moment
}

export const ElectricityChartTitle: FC<ElectricityChartTitleProps> = React.memo(
  ({toggleEcChart, isEcChartOpen, shouldShowDeltaTooltip, lastUpdated, ...boxProps}) => {
    const timezoneId = useUpmPlantTimezone()
    const {
      t,
      i18n: {language}
    } = useTranslation(FEATURE_NAMESPACE)

    return (
      <Stack
        direction="row"
        spacing={0.5}
        sx={(theme) => ({
          justifyContent: 'flex-end',
          alignItems: 'start',
          pr: 1,
          color: 'currentColor',
          cursor: 'pointer',
          ...theme.typography.h2
        })}
        onClick={toggleEcChart}
        {...boxProps}
      >
        {isEcChartOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
        <Stack>
          <Stack direction="row" spacing={0.5}>
            <Typography variant="h3" sx={{textTransform: 'initial'}}>
              {t('planning.mwPlanned')}
            </Typography>
            {shouldShowDeltaTooltip && (
              <Tooltip
                arrow
                placement="right-end"
                title={<Typography variant="body1">{t('planning.deltaDescription')}</Typography>}
              >
                <InfoOutlinedIcon color="primary" />
              </Tooltip>
            )}
          </Stack>
          {lastUpdated && (
            <Typography variant="body1" sx={{color: 'text.secondary'}}>
              {t('common.lastUpdate', {
                date: getLocalizedDayMonthTimeFormat(lastUpdated, timezoneId, language)
              })}
            </Typography>
          )}
        </Stack>
      </Stack>
    )
  }
)

ElectricityChartTitle.displayName = 'ElectricityChartTitle'
